import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['item']

  filter(event) {
    const phrase = event.target.value.toLowerCase()
    this.itemTargets.forEach(item => {
      item.hidden = !item.textContent.toLowerCase().includes(phrase)
    })
  }
}
